import { useCallback, useState } from 'react';
import { sortRowsByColumn } from '../utils/tableClientSort';

export function useClientTableSort(setRows) {
  const [headerSort, setHeaderSort] = useState({ column: null, order: null });

  const resetSort = useCallback(() => {
    setHeaderSort({ column: null, order: null });
  }, []);

  const sortByColumn = useCallback(
    (columnKey, descending) => {
      setHeaderSort({ column: columnKey, order: descending ? 1 : 0 });
      setRows((prev) => (Array.isArray(prev) ? sortRowsByColumn(prev, columnKey, descending) : prev));
    },
    [setRows]
  );

  return { headerSort, sortByColumn, resetSort };
}
